import { HtmlHelper } from '@/helper/htmlHelper';
import { MathHelper } from '@/helper/mathHelper';
import { RequestHelper } from './requestHelper';
import { UserAgentHelper } from './userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { FileHelper } from './fileHelper';
import { UnitHelper } from './unitHelper';
import { Const } from '@/const';
import { ColorConstruct } from '@/utilityModels/colorConstruct';

export class ImageHelper
{
    // SVGElement -> base64 image
    public static convertSVGElementToBase64(svg) : string
    {
        var svgData = HtmlHelper.convertElementToTag(svg);
        DebugHelper.trace(svgData)
        return this.convertSVGTagToBase64(svgData);
    }

    // SVGTag -> base64 image
    public static convertSVGTagToBase64(svgTag) : string
    {
        svgTag = this.fixSVGTag(svgTag);
        var image = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgTag)));
        return image;
    }

    // Uint8array -> base64 image
    public static convertBufferToBase64(buf : Uint8Array) : string
    {
        var result = "";
        try
        {
            var mime = "";
            var nb = buf.length;
            if (nb < 4)
                return "";
            var b0 = buf[0];
            var b1 = buf[1];
            var b2 = buf[2];
            var b3 = buf[3];
            if (b0 == 0x89 && b1 == 0x50 && b2 == 0x4E && b3 == 0x47)
                mime = 'image/png';
            else if (b0 == 0xff && b1 == 0xd8)
                mime = 'image/jpeg';
            else if (b0 == 0x47 && b1 == 0x49 && b2 == 0x46)
                mime = 'image/gif';
            else if (b0 == 0x42 && b1 == 0x4d)
                mime = 'image/bmp';
            else if (b0 == 0x00 && b1 == 0x00)
                mime = 'image/x-icon';
            else if (b0 == 0x52 && b1 == 0x49 && b2 == 0x46 && b3 == 0x46)
                mime = 'image/webp';
            else
                mime = '';
            var binary = "";
            for (var i = 0; i < nb; i++)
                binary += String.fromCharCode(buf[i]);
            if(mime == '')
            {
                // SVGか判定
                if(this.detectStringAsSVG(binary))
                {
                    mime = 'image/svg+xml';
                }
                else
                {
                    return '';
                }
            }
            var base64 = window.btoa(binary);
            result = 'data:' + mime + ';base64,' + base64;
        }
        catch (ex)
        {
            DebugHelper.trace(ex);
        }

        return result;
    }

    // 文字列がSVGかどうか判定する
    public static detectStringAsSVG(str : string)
    {
        DebugHelper.trace(str)
        var result = false;
        try
        {
            var parser = new DOMParser();
            var doc = parser.parseFromString(str, "image/svg+xml");
            
            var err = doc.getElementsByTagName("parsererror");
            result = err == null || err.length == 0;
        }
        catch
        {
        }
        return result;
    }

    // base64 image -> SVGTag
    public static convertBase64ToSVGTag(base64 : string) : string
    {
        var result = "";
        try
        {
            // header削除
            var header = "data:image/svg+xml;base64,";
            if(base64.length >= header.length && base64.substr(0, header.length) == header)
            {
                base64 = base64.substr(header.length, base64.length - header.length);
            }
            // 変換
            result = decodeURIComponent(unescape(atob(base64)));
        }
        catch(e)
        {
            result = ""
        }
        return result;
    }

    // base64 svg に対して、線幅と線の色を設定する
    public static changeBase64SVGStroke(base64 : string, width : number, color : ColorConstruct, vectorEffect : string)
    {
        // Image to Tag
        var tag = this.convertBase64ToSVGTag(base64);
        if (tag == "") return base64;

        var newBase64 = base64;
        try
        {
            // Tagをシリアライズ
            var parser = new DOMParser();
            var doc = parser.parseFromString(tag, "image/svg+xml");
            
            // 探す図形
            var shapes = ["path", "rect", "circle", "ellipse", "line", "polyline", "polygon"];
            for(var s = 0; s < shapes.length; ++s)
            {
                var shape = shapes[s];
                // 図形をさがす
                var pathElements = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", shape);
                for(var i = 0; i < pathElements.length; ++i)
                {
                    // pathの線属性変更
                    pathElements[i].setAttribute("stroke", color.hex);
                    pathElements[i].setAttribute("stroke-width", "" + width);
                    pathElements[i].setAttribute("vector-effect", vectorEffect);
                }

            }

            var serializer = new XMLSerializer();
            var newTag = serializer.serializeToString(doc);

            // Tag to Image
            newBase64 = this.convertSVGTagToBase64(newTag)
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return newBase64;
    }

    // base64 -> blob
    // *ieかつpngのみ
    public static convertBase64ToBlobIfNeeded(base64Image : string) : string
    {
        var result = base64Image;
        try
        {
            if(UserAgentHelper.getBrowser() == "ie" && base64Image.indexOf("data:image/png;base64,") >= 0)
            {
                // base64のデータ部分 -> binary
                var bin = atob(base64Image.split(',')[1].replace(/\r?\n/g, ""));
                // binary -> buffer
                var buffer = new Uint8Array(bin.length);
                for(var i = 0; i < bin.length; ++i)
                {
                    buffer[i] = bin.charCodeAt(i);
                }
                // buffer -> blob
                var blob = new Blob([buffer.buffer], {type : "image/png"});
                result = FileHelper.createUrl(blob);
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return result;
    }

    // ラスタライズが必要なSVGかどうか判定する
    // 非対応とするSVGタグ
    private static UNSUPPORTED_SVG_TAGS = ["use", "text"];
    public static isSVGRasterizeNeeded(base64 : string) : boolean
    {
        var result = false;
        try
        {
            var header = "data:image/svg+xml;base64,";
            var headerIndex = base64.indexOf(header);
            if(headerIndex >= 0)
            {
                var encoded = base64.substring(headerIndex + header.length);
                var tag = decodeURIComponent(escape(atob(encoded)));
                var parser = new DOMParser();
                var doc = parser.parseFromString(tag, 'text/xml');

                for(var i = 0; i < this.UNSUPPORTED_SVG_TAGS.length; ++i)
                {
                    var unsupportedTag = this.UNSUPPORTED_SVG_TAGS[i];
                    var elements = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", unsupportedTag);
                    result = elements.length > 0;

                    if(result) { break; }
                }
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return result;
    }

    public static fixSVGTag(svgTag) : string
    {
        var fixed = svgTag;
        // IEの場合xmlnが2カ所に書かれることがあり、これがバグを生むので削除する
        if(svgTag.indexOf("<svg") == 0)
        {
            var svgTag2 = svgTag.substr("<svg".length);
            var closeIndex = svgTag2.indexOf(">");
            if(closeIndex >= 0)
            {
                var headerCount = "<svg".length + closeIndex + 1;
                var svgHeader = svgTag.substr(0, headerCount);
                var svgContent = svgTag.substr(headerCount);
                var xlmnCount = (svgHeader.match(/xmlns=/gi) || []).length;
                if(xlmnCount >= 2)
                {
                    for(var i = 0; i < xlmnCount - 1; ++i)
                    {
                        svgHeader = svgHeader.replace('xmlns="http://www.w3.org/2000/svg"', '');
                    }
                }
                fixed = svgHeader + svgContent;
            }
        }

        return fixed;
    }

    // SVGTag -> png image (base64)
    // 対応していないCSSがあるので、このコンバートは使用しない
    // public static convertSVGTagToPng(svgTag, width, height, completion : (image : string) => void )
    // {
    //     var canvg = require('canvg');

    //     var canvas = this.createOffScreenCanvas(width, height);
    //     if(canvas == null) { return; }
    //     canvg(canvas, svgTag, { renderCallback : function()
    //     {
    //         if(canvas != null)
    //         {
    //             var image = canvas.toDataURL("image/png");
    //             completion(image);
    //         }
    //     }});
    // }

    // 画像サイズ取得
    public static getImageSize(image : string, completion : (size : {width : number, height : number}) => void)
    {
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var size = { width : imageElement.width, height : imageElement.height };
            if((size.width <= 0 || size.height <= 0) && ImageHelper.isSvg(image))
            {
                try
                {
                    // SVGは一部ブラウザでサイズが取れない場合があるので、base64からタグに変換して、サイズ情報を得る
                    var tag = ImageHelper.convertBase64ToSVGTag(image);
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(tag, "image/svg+xml");
                    var svgEle = doc.getElementsByTagName("svg")[0];
                    var rect = svgEle.viewBox.baseVal;
                    size.width = rect.width;
                    size.height = rect.height;
                }
                catch(e)
                {
                    DebugHelper.trace(e);
                }
            }
            completion(size);
        }
        imageElement.src = image;
    }

    // キャンバスに合わせたサイズを得る
    public static fitImageSize(image: Size, canvas: Size): Size
    {
        // 0でないことを信じて
        // if (canvas.width === 0 || canvas.height === 0 || image.width === 0 || image.height === 0)
        // {
        //     return {width: 0, height: 0};
        // }
        // 大きいことを信じて
        // if (image.width <= canvas.width && image.height <= canvas.height)
        // {
        //     return {width: image.width, height: image.height};
        // }
        const aspectRatio = image.width / image.height;
        const width = canvas.width;
        const height = canvas.width / aspectRatio;
        if (height > canvas.height)
        {
            return {
                width: canvas.height * aspectRatio,
                height: canvas.height
            };
        }
        return { width, height };
    }

    // 半分のサイズを得る
    public static halfSize(image: Size): Size
    {
        return {
            width: image.width / 2,
            height: image.height / 2,
        };
    }

    // crop image(base64)
    // x, y, width, height はそれぞれ100で正規化
    public static cropImageNormalized(srcImage : string, x, y, width, height, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(srcImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var fx = imageElement.width * x / 100;
            var fy = imageElement.height * y / 100;
            var fw = imageElement.width * width / 100;
            var fh = imageElement.height * height / 100;

            var canvas = ImageHelper.createOffScreenCanvas(fw, fh);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    // Cropのときはスムージングしない
                    ctx.imageSmoothingEnabled = false;
                    ctx.drawImage(imageElement, fx, fy, fw, fh, 0, 0, fw, fh);
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        }
        imageElement.src = srcImage;
    }

    // tile image(base64)
    public static tileImage(srcImage : string, horintalTiles : number, verticalTiles : number, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(srcImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvasW = imageElement.width * horintalTiles;
            var canvasH = imageElement.height * verticalTiles;

            var canvas = ImageHelper.createOffScreenCanvas(canvasW, canvasH);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    // タイリングのときはスムージングしない
                    ctx.imageSmoothingEnabled = false;
                    for(var h = 0; h < horintalTiles; ++h)
                    {
                        for(var v = 0; v < verticalTiles; ++v)
                        {
                            ctx.drawImage(imageElement, h * imageElement.width, v * imageElement.height, imageElement.width, imageElement.height);
                        }
                    }
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        }
        imageElement.src = srcImage;
    }

    // イメージ回転
    public static rotateImage(srcImage : string, rotate : number, completion : (image : string) => void)
    {
        // 回転角を0以上360未満にする
        var fixRotate = rotate;
        while(fixRotate < 0) { fixRotate += 360; }
        while(fixRotate >= 360) { fixRotate -= 360; }

        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvasW = fixRotate == 90 || fixRotate == 270 ? imageElement.height : imageElement.width;
            var canvasH = fixRotate == 90 || fixRotate == 270 ? imageElement.width : imageElement.height;

            var canvas = ImageHelper.createOffScreenCanvas(canvasW, canvasH);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    // 回転
                    ctx.rotate(fixRotate * Math.PI / 180);
                    if(fixRotate == 90) { ctx.translate(0, -imageElement.height); }
                    else if(fixRotate == 180) { ctx.translate(-imageElement.width, -imageElement.height); }
                    else if(fixRotate == 270) { ctx.translate(-imageElement.width, 0); }
                    ctx.drawImage(imageElement, 0, 0, imageElement.width, imageElement.height);
                    var image = canvas.toDataURL("image/png");
                    completion(image);
                }
            }
        }
        imageElement.src = srcImage;
    }

    // SVG image -> png image (base64)
    // rotate: キャンバスの回転角
    public static convertSVGImageToPng(svgImage : string, width, height, rotate, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(svgImage);
        // 回転角を元に戻すため、正負を入れ替える
        var fixRotate = -rotate;
        // 回転角を0以上360未満にする
        while(fixRotate < 0) { fixRotate += 360; }
        while(fixRotate >= 360) { fixRotate -= 360; }

        var imageElement = new Image();
        imageElement.onload = function()
        {
            var newWidth = (fixRotate == 90 || fixRotate == 270) ? height : width;
            var newHeight = (fixRotate == 90 || fixRotate == 270) ? width : height;
            var canvas = ImageHelper.createOffScreenCanvas(newWidth, newHeight);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.rotate(fixRotate * Math.PI / 180);
                    if(fixRotate == 90) { ctx.translate(0, -height); }
                    else if(fixRotate == 180) { ctx.translate(-width, -height); }
                    else if(fixRotate == 270) { ctx.translate(-width, 0); }
                    ctx.drawImage(imageElement, 0, 0, width, height);
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        }
        imageElement.src = svgImage;
    }

    // 画像にフィルタ加工して返す base64 -> base64
    // sourceImage : 元画像
    // r : 色変更赤
    // g : 色変更緑
    // b : 色変更青
    // isWhiteTransparent : 白色透明化する(r/g/bが0以外の場合は無視)
    // blurRadius : ぼかし半径(px)
    // completion : 終了時のコールバック
    public static createFilteredImage(sourceImage : string, r : number, g : number, b : number, isWhiteTransparent : boolean, blurRadius : number, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(sourceImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.drawImage(imageElement, 0, 0);
                    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    // 色変更
                    var isColored = !MathHelper.equals(r, 0) || !MathHelper.equals(g, 0) || !MathHelper.equals(b, 0);
                    if(isColored)
                    {
                        ImageHelper.colorImageData(imageData, imageData, r, g, b);
                    }
                    // 白色透明化
                    if(!isColored && isWhiteTransparent)
                    {
                        ImageHelper.whiteTransparentImageData(imageData, imageData);
                    }
                    // ガウスぼかし
                    if(blurRadius > 0)
                    {
                        var radius = blurRadius;
                        var glur = require('glur');
                        glur(imageData.data, canvas.width, canvas.height, radius);
                    }
                    ctx.putImageData(imageData, 0, 0);
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        };
        imageElement.src = sourceImage;
    }

    // 画像をカラー加工して返す base64 -> base64
    public static createColoredImage(sourceImage : string, r : number, g : number, b : number, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(sourceImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.drawImage(imageElement, 0, 0);
                    var srcData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    var dstData = ctx.createImageData(canvas.width, canvas.height);
                    ImageHelper.colorImageData(srcData, dstData, r, g, b);
                    ctx.putImageData(dstData, 0, 0);
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        };
        imageElement.src = sourceImage;
    }

    // 画像を白色透明化して返す base64 -> base64
    public static createWhiteTransparentImage(sourceImage : string, completion : (image : string) => void)
    {
        var process = (image : string, isSvgFixed : boolean) =>
        {
            var imageElement = new Image();
            imageElement.onload = function()
            {
                // SVGの場合、劣化を防ぐため4倍にする
                var imageWidth = imageElement.width * (isSvgFixed ? 4 : 1);
                var imageHeight = imageElement.height * (isSvgFixed ? 4 : 1);
                var canvas = ImageHelper.createOffScreenCanvas(imageWidth, imageHeight);
                if(canvas != null)
                {
                    var ctx = canvas.getContext('2d');
                    if(ctx != null)
                    {
                        ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
                        var srcData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        var dstData = ctx.createImageData(canvas.width, canvas.height);
                        ImageHelper.whiteTransparentImageData(srcData, dstData);
                        ctx.putImageData(dstData, 0, 0);
                        ImageHelper.canvas2png(canvas, isSvgFixed, completion);
                    }
                }
            };
            imageElement.src = image;
        };

        var isSvg = this.isSvg(sourceImage);
        var browser = UserAgentHelper.getBrowser();
        if(isSvg && (browser == "ie" || browser == "firefox"))
        {
            // svgで一部ブラウザの場合は、サーバーでpngに変換して処理する
            isSvg = false;
            ImageHelper.getImageSize(sourceImage, size =>
            {
                ImageHelper.svg2pngOnServer(sourceImage,  size.width * 4, size.height * 4, (pngImage) =>
                {
                    process(pngImage, false);
                });
            });
        }
        else
        {
            process(sourceImage, isSvg);
        }
    }

    // 画像を白色から指定した色に変えて返す base64 -> base64
    public static createWhiteOptionalColorImage(sourceImage : string, optionalColor : {r : number , g: number, b : number, a: number} , completion : (image : string) => void)
    {
        var isSvg = this.isSvg(sourceImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.drawImage(imageElement, 0, 0);
                    var srcData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    var dstData = ctx.createImageData(canvas.width, canvas.height);
                    ImageHelper.whiteOptionalColorImageData(srcData, optionalColor, dstData);
                    ctx.putImageData(dstData, 0, 0);
                    ImageHelper.canvas2png(canvas, isSvg, completion);
                }
            }
        };
        imageElement.src = sourceImage;
    }

    // byte array (Array<number>) -> base64 image
    public static convertARGBByteArrayToBase64(argbData : Array<number> | Uint8Array, width : number, height : number)
    {
        var image = "";
        var canvas = ImageHelper.createOffScreenCanvas(width, height);
        if(canvas != null)
        {
            var ctx = canvas.getContext('2d');
            if(ctx != null)
            {
                var srcIndex = 0;
                var dstIndex = 0;
                var curPixelIndex = 0;
                var imageData = ctx.createImageData(width, height);
                for(curPixelIndex = 0; curPixelIndex < width * height; ++curPixelIndex)
                {
                    imageData.data[dstIndex] = argbData[srcIndex + 1];
                    imageData.data[dstIndex + 1] = argbData[srcIndex + 2];
                    imageData.data[dstIndex + 2] = argbData[srcIndex + 3];
                    imageData.data[dstIndex + 3] = argbData[srcIndex];
                    srcIndex += 4;
                    dstIndex += 4;
                }

                ctx.putImageData(imageData, 0, 0);
                image = canvas.toDataURL("image/png");

            }
        }

        return image;
    }

    // byte array (Array<number>) -> base64 image (白色透明化)
    public static convertARGBByteArrayToBase64WhiteTransparent(argbData : Array<number> | Uint8Array, width : number, height : number)
    {
        var image = "";
        var canvas = ImageHelper.createOffScreenCanvas(width, height);
        if(canvas != null)
        {
            var ctx = canvas.getContext('2d');
            if(ctx != null)
            {
                var srcIndex = 0;
                var dstIndex = 0;
                var curPixelIndex = 0;
                var imageData = ctx.createImageData(width, height);
                for(curPixelIndex = 0; curPixelIndex < width * height; ++curPixelIndex)
                {
                    if(argbData[srcIndex + 1] == 255 && argbData[srcIndex + 2] == 255 && argbData[srcIndex + 3] == 255)
                    {
                        // 透明にする
                        imageData.data[dstIndex] = 0;
                        imageData.data[dstIndex + 1] = 0;
                        imageData.data[dstIndex + 2] = 0;
                        imageData.data[dstIndex + 3] = 0;
                    }
                    else
                    {
                        imageData.data[dstIndex] = argbData[srcIndex + 1];
                        imageData.data[dstIndex + 1] = argbData[srcIndex + 2];
                        imageData.data[dstIndex + 2] = argbData[srcIndex + 3];
                        imageData.data[dstIndex + 3] = argbData[srcIndex];
                    }
                    srcIndex += 4;
                    dstIndex += 4;
                }

                ctx.putImageData(imageData, 0, 0);
                image = canvas.toDataURL("image/png");

            }
        }

        return image;
    }

    private static colorImageData(srcData : ImageData, dstData : ImageData, r : number, g : number, b : number)
    {
        var srcRawData = srcData.data;
        var dstRawData = dstData.data;
        for(var i = 0; i < srcData.height; ++i)
        {
            for(var j = 0; j < srcData.width; ++j)
            {
                var index = (j + i * srcData.width) * 4;
                dstRawData[index] = MathHelper.clamp(srcRawData[index] + r, 0, 255);            // R
                dstRawData[index + 1] = MathHelper.clamp(srcRawData[index + 1] + g, 0, 255);    // G
                dstRawData[index + 2] = MathHelper.clamp(srcRawData[index + 2] + b, 0, 255);    // B
                dstRawData[index + 3] = srcRawData[index + 3];                                  // Alpha
            }
        }
    }

    private static whiteTransparentImageData(srcData : ImageData, dstData : ImageData)
    {
        var srcRawData = srcData.data;
        var dstRawData = dstData.data;
        for(var i = 0; i < srcData.height; ++i)
        {
            for(var j = 0; j < srcData.width; ++j)
            {
                var index = (j + i * srcData.width) * 4;
                if(srcRawData[index] == 255 &&
                    srcRawData[index + 1] == 255 &&
                    srcRawData[index + 2] == 255)
                {
                    // 白色 -> 透明色にする
                    dstRawData[index] = 0;
                    dstRawData[index + 1] = 0;
                    dstRawData[index + 2] = 0;
                    dstRawData[index + 3] = 0;
                }
                else
                {
                    // それ以外 -> 変更なし
                    dstRawData[index] = srcRawData[index];
                    dstRawData[index + 1] = srcRawData[index + 1];
                    dstRawData[index + 2] = srcRawData[index + 2];
                    dstRawData[index + 3] = srcRawData[index + 3];
                }
            }
        }
    }

    private static whiteOptionalColorImageData(srcData : ImageData, optionalColor : { r : number , g : number , b : number , a : number } ,  dstData : ImageData)
    {
        var srcRawData = srcData.data;
        var dstRawData = dstData.data;
        for(var i = 0; i < srcData.height; ++i)
        {
            for(var j = 0; j < srcData.width; ++j)
            {

                var index = (j + i * srcData.width) * 4;
                if(srcRawData[index] == 255 &&
                    srcRawData[index + 1] == 255 &&
                    srcRawData[index + 1] == 255)
                {
                    // 白色 -> optionalColorにする
                    dstRawData[index] = optionalColor.r;
                    dstRawData[index + 1] = optionalColor.g;
                    dstRawData[index + 2] = optionalColor.b;
                    dstRawData[index + 3] = optionalColor.a;
                }
                else
                {
                    // それ以外 -> 変更なし
                    dstRawData[index] = srcRawData[index];
                    dstRawData[index + 1] = srcRawData[index + 1];
                    dstRawData[index + 2] = srcRawData[index + 2];
                    dstRawData[index + 3] = srcRawData[index + 3];
                }
            }
        }
    }

    // 表示されないキャンバスを作成する
    static readonly OFF_SCREEN_CANVAS_ID = "svgOffScreenRenderCanvas";
    static readonly OFF_SCREEN_CANVAS_CLASS = "svg-off-screen-render-canvas";

    private static createOffScreenCanvas(width, height)
    {
        var body = document.querySelector('body');
        if(!body) { return null; }

        // 念のため古いキャンバス消去
        ImageHelper.deleteOffScreenCanvas();

        var newCanvas = document.createElement('canvas');
        newCanvas.setAttribute('id', this.OFF_SCREEN_CANVAS_ID)
        newCanvas.setAttribute('width', width);
        newCanvas.setAttribute('height', height);

        // styleの設定で表示範囲外に飛ばす
        var style = newCanvas.style;
        style.position = 'absolute';
        style.left = (-1 * width) + 'px';
        style.top = '0px';

        newCanvas.classList.add(this.OFF_SCREEN_CANVAS_CLASS);
        body.appendChild(newCanvas);
        return newCanvas;
    }

    // 表示されないキャンバスを消去する
    private static deleteOffScreenCanvas()
    {
        var body = document.querySelector('body');
        if(!body) { return; }

        var canvas = document.getElementById(this.OFF_SCREEN_CANVAS_ID);
        if(canvas)
        {
            // もしキャンバスが存在していたら消去する。
            body.removeChild(canvas);
        }
    }

    public static isSvg(base64 : string)
    {
        return this.getDataUrlImageExtension(base64) == "svg";
    }
    
    public static getDataUrlImageExtension(base64 : string)
    {
        if(base64.indexOf("data:image/svg+xml;base64,") == 0) return "svg";
        if(base64.indexOf("data:image/bmp;base64,") == 0) return "bmp";
        let contents = base64.split(',');
        let content = contents.length > 1 ? contents[1] : "";
        let head = content.length >= 4 ? content.substr(0, 4) : "";
        if(head == "iVBO") return "png";
        else if(head == "/9j/") return "jpg";
        else if(head == "R0lG") return "gif";
        else return "undefined";
    }

    static readonly BASE64_MARKER = ';base64,';

    // png -> jpg
    public static png2jpg(pngImage : string, completion : (image : string) => void)
    {
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.drawImage(imageElement, 0, 0);
                    var jpgImage = canvas.toDataURL("image/jpeg");
                    completion(jpgImage);
                }
            }
        };
        imageElement.src = pngImage;
    }

    // サーバーでSVGをPNGに変換する
    public static svg2pngOnServer(svgImage : string, width : number, height : number, completion : (image : string) => void): void
    {
        var base64Idx = svgImage.indexOf(this.BASE64_MARKER) + this.BASE64_MARKER.length;
        var base64 = base64Idx >= 0 ? svgImage.substring(base64Idx) : svgImage;
        var raw = atob(base64);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for(var i = 0; i < rawLength; ++i)
        {
            array[i] = raw.charCodeAt(i);
        }

        var buf = array.buffer as ArrayBuffer;

        var postData = {};
        postData["sizeW"] = width / 72 * 96;
        postData["sizeH"] = height / 72 * 96;

        RequestHelper.postBinaryWithData("svg_to_png", postData, buf, "svgFile.svg", "image/svg+xml", (response) =>
        {
            DebugHelper.trace(response);
            completion(response);
        },
        () => {
            DebugHelper.trace("convert error!");
            completion("");
        });
    }

    // ローカルでSVGをPNGに変換する
    public static svg2pngOnClient(svgImage : string, width : number, height : number, completion : (image : string) => void): void
    {
        if (UserAgentHelper.getBrowser() === 'ie') {
            // IEではDataURLに変換できない
            // Firefoxでも画像が粗いし、他でもWebフォントは出力できないけど保留
            // TODO canvgなどを描画エンジンに据えると変換できるって話もある
            completion('');
            return;
        }
        var imageElement = new Image();
        imageElement.onload = function()
        {
            try {
                var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
                if(canvas != null)
                {
                    var ctx = canvas.getContext('2d');
                    if(ctx != null)
                    {
                        ctx.drawImage(imageElement, 0, 0);
                        var pngImage = canvas.toDataURL("image/png");
                        completion(pngImage);
                    }
                }
            } catch (e) {
                DebugHelper.trace('svg2png is failed');
                completion('');
            }
        };
        imageElement.src = svgImage;
        imageElement.width = width;
        imageElement.height = height;
    }

    // svg base64 -> png base64
    public static svg2png(svgImage : string, width : number, height : number, completion : (image : string) => void): void
    {
        this.svg2pngOnServer(svgImage, width, height, (image) => {
            if (image === '') {
                // 通信に失敗した場合
                this.svg2pngOnClient(svgImage, width, height, completion);
            } else {
                completion(image);
            }
        });
    }

    private static canvas2png(canvas : HTMLCanvasElement, isSvg : boolean, completion : (image : string) => void)
    {
        try
        {
            if(UserAgentHelper.getBrowser() == "ie" && isSvg)
            {
                var dataurl = canvas.toDataURL("image/svg+xml");
                var base64Idx = dataurl.indexOf(this.BASE64_MARKER) + this.BASE64_MARKER.length;
                var base64 = dataurl.substring(base64Idx);
                var raw = atob(base64);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for(var i = 0; i < rawLength; ++i)
                {
                    array[i] = raw.charCodeAt(i);
                }

                var buf = array.buffer as ArrayBuffer;

                RequestHelper.postBinary("svg_to_png", buf, "svgFile.svg", "image/svg+xml", (response) =>
                {
                    completion(response);
                },
                () => {
                    DebugHelper.trace("convert error!");
                    completion("");
                });
            }
            else
            {
                var pngImage = canvas.toDataURL("image/png");
                completion(pngImage);
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
            completion("");
        }
    }

    public static getImageFromUrl(url : string, completion : (image : string) => void)
    {
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(imageElement.width, imageElement.height);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.drawImage(imageElement, 0, 0);
                    var pngImage = canvas.toDataURL("image/png");
                    completion(pngImage);
                }
            }
        };
        imageElement.crossOrigin = 'anonymous';
        imageElement.src = url;
    }

    // 画像サイズが大きすぎるか
    // dstWidth, dstHeight : 貼り付け先の幅・高さ、ここにAspect Fitする
    public static isImageSizeTooMuch(imageWidth : number, imageHeight : number, dstWidth : number, dstHeight : number)
    {
        // 適切なサイズに対する縦か横のサイズオーバー確認
        var properSize = this.calcProperSize(imageWidth, imageHeight, dstWidth, dstHeight);
        return properSize.width < imageWidth || properSize.height < imageHeight;
    }

    // 画像の適切なサイズを取得する
    // 大きすぎる画像の対応のため
    // dstWidth, dstHeight : 貼り付け先の幅・高さ
    public static calcProperSize(imageWidth : number, imageHeight : number, dstWidth : number, dstHeight : number)
    {
        // 貼り付け先を規定DPIでpx変換
        var dstWidthPx = UnitHelper.convert(dstWidth, "mm", "px", Const.IMAGE_TOO_LARGE_DPI);
        var dstHeightPx = UnitHelper.convert(dstHeight, "mm", "px", Const.IMAGE_TOO_LARGE_DPI);

        // 長辺の拡大率
        var scale = Math.max(dstWidthPx, dstHeightPx) / Math.max(imageWidth, imageHeight);

        return { width : imageWidth * scale, height : imageHeight * scale };
    }

    // 画像のリサイズ
    public static resizeImage(srcImage : string, newWidth : number, newHeight : number, completion : (image : string) => void)
    {
        var isSvg = this.isSvg(srcImage);
        var imageElement = new Image();
        imageElement.onload = function()
        {
            var canvas = ImageHelper.createOffScreenCanvas(newWidth, newHeight);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.imageSmoothingEnabled = true;
                    ctx.drawImage(imageElement, 0, 0, newWidth, newHeight);
                    let extension = ImageHelper.getDataUrlImageExtension(srcImage);
                    if(extension == "jpg")
                    {
                        // jpgの場合は canvas -> jpg
                        DebugHelper.trace("canvas to jpg");
                        let jpg = canvas.toDataURL("image/jpeg", 0.85);
                        completion(jpg);
                    }
                    else
                    {
                        // それ以外は canvas -> png
                        DebugHelper.trace("canvas to png");
                        ImageHelper.canvas2png(canvas, isSvg, completion);
                    }
                }
            }
        }
        imageElement.src = srcImage; 
    }

    // SVG image -> jpeg image (base64)
    // rotate: キャンバスの回転角
    public static convertSVGImageToJpeg(svgImage : string, width, height, rotate, completion : (image : string) => void)
    {
        if(UserAgentHelper.isElectron())
        {
            // Electronでは呼ばないことを推奨
            DebugHelper.trace("ElectronでconvertSVGImageToJpegが呼ばれています！");
        }
        // canvas -> jpeg変換ではフォントがうまく適用されないので
        // 原則サーバ変換を行う。
        ImageHelper.svg2png(svgImage, width, height, png =>
        {
            if(png == null || png == "")
            {
                // 処理失敗
                completion("");
            }
            else if(png.split(',')[1] == "")
            {
                // 処理失敗
                completion("");
            }
            else
            {
                // 処理続行
                this.convertImageToJpegOnLocal(png, width, height, rotate, completion);
            }
        });
    }
    public static convertImageToJpegOnLocal(image : string, width, height, rotate, completion : (image : string) => void)
    {
        // 回転角を元に戻すため、正負を入れ替える
        var fixRotate = -rotate;
        // 回転角を0以上360未満にする
        while(fixRotate < 0) { fixRotate += 360; }
        while(fixRotate >= 360) { fixRotate -= 360; }

        var imageElement = new Image();
        imageElement.onload = function()
        {
            var newWidth = (fixRotate == 90 || fixRotate == 270) ? height : width;
            var newHeight = (fixRotate == 90 || fixRotate == 270) ? width : height;
            var canvas = ImageHelper.createOffScreenCanvas(newWidth, newHeight);
            if(canvas != null)
            {
                var ctx = canvas.getContext('2d');
                if(ctx != null)
                {
                    ctx.rotate(fixRotate * Math.PI / 180);
                    if(fixRotate == 90) { ctx.translate(0, -height); }
                    else if(fixRotate == 180) { ctx.translate(-width, -height); }
                    else if(fixRotate == 270) { ctx.translate(-width, 0); }
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillRect(0, 0, width, height);
                    ctx.drawImage(imageElement, 0, 0, width, height);
                    let jpg = canvas.toDataURL("image/jpeg");
                    completion(jpg);
                }
            }
        }
        imageElement.src = image;
    }
}
